var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "nav profile", class: _vm.isProfileMenuOpen && "is-open" },
    [
      _c(
        "button",
        {
          staticClass: "profile__btn",
          attrs: { "data-testid": "profile-menu-name-label" },
          on: { click: _vm.displayProfileMenu }
        },
        [
          _c(
            "span",
            {
              staticClass: "profile__name-badge",
              attrs: { "data-testid": "profile-menu-initials" }
            },
            [_vm._v(" " + _vm._s(_vm.profileMenuResults.userInitials) + " ")]
          ),
          _vm.messageCenterLinkType() === "Url"
            ? _c(
                "a",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.profileMenuResults.unreadCount > 0,
                      expression: "profileMenuResults.unreadCount > 0"
                    }
                  ],
                  staticClass: "profile__badge-count ignoreBadgeClick",
                  attrs: {
                    href: _vm.messageCenterURL,
                    "data-testid": "profile-menu-unread-count"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.profileMenuResults.unreadCount) + " ")]
              )
            : _vm._e(),
          _vm.messageCenterLinkType() === "route"
            ? _c(
                "router-link",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.profileMenuResults.unreadCount > 0,
                      expression: "profileMenuResults.unreadCount > 0"
                    }
                  ],
                  staticClass: "profile__badge-count ignoreBadgeClick",
                  attrs: {
                    to: _vm.messageCenterURL,
                    "data-testid": "profile-menu-unread-count"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.profileMenuResults.unreadCount) + " ")]
              )
            : _vm._e(),
          _c("span", { staticClass: "profile__name" }, [
            _vm._v(" " + _vm._s(_vm.profileMenuResults.userName) + " ")
          ]),
          _vm._m(0)
        ],
        1
      ),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isProfileMenuOpen,
              expression: "isProfileMenuOpen"
            }
          ],
          staticClass: "profile__menu",
          attrs: { "data-testid": "profile-menu-items-menu" }
        },
        [
          _vm._l(_vm.profileItems, function(menuItem) {
            return _c(
              "li",
              { key: menuItem.name, staticClass: "profile__menu-item" },
              [
                _vm.isUrlLink(menuItem)
                  ? _c(
                      "a",
                      {
                        staticClass: "profile__menu-item-link",
                        attrs: {
                          href: menuItem.url,
                          target: menuItem.target,
                          "data-testid": "profile-menu-accessweb-link"
                        },
                        on: { click: _vm.onMenuItemClick }
                      },
                      [
                        _vm._v(_vm._s(menuItem.name) + " "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.profileMenuResults.unreadCount > 0 &&
                                  menuItem.name === "Message Center",
                                expression:
                                  "\n\t\t\t\t\t\tprofileMenuResults.unreadCount > 0 &&\n\t\t\t\t\t\t\tmenuItem.name === 'Message Center'\n\t\t\t\t\t"
                              }
                            ],
                            staticClass: "profile__badge-count"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.profileMenuResults.unreadCount) +
                                " "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                !_vm.isUrlLink(menuItem)
                  ? _c(
                      "router-link",
                      {
                        staticClass: "profile__menu-item-link",
                        attrs: {
                          to: menuItem.url,
                          "data-testid": "profile-menu-router-link"
                        },
                        on: { click: _vm.onMenuItemClick }
                      },
                      [
                        _vm._v(_vm._s(menuItem.name) + " "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.profileMenuResults.unreadCount > 0 &&
                                  menuItem.name === "Message Center",
                                expression:
                                  "\n\t\t\t\t\t\tprofileMenuResults.unreadCount > 0 &&\n\t\t\t\t\t\t\tmenuItem.name === 'Message Center'\n\t\t\t\t\t"
                              }
                            ],
                            staticClass: "profile__badge-count"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.profileMenuResults.unreadCount) +
                                " "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          }),
          _c("li", { staticClass: "profile__menu-item" }, [
            _c(
              "a",
              {
                staticClass: "profile__menu-item-link",
                attrs: { "data-testid": "profile-menu-log-off" },
                on: { click: _vm.logout }
              },
              [_vm._v("Log Off")]
            )
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "profile__expand-icon" }, [
      _c("i", { staticClass: "icon icon-arrow_down_filled" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }